import { IClassname } from '@/lib/shared/model/classname';

export const Billiard = ({ className }: IClassname) => {
  return (
    <svg
      width="32"
      className={className}
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.4181 20.4723V6.41521C29.6709 6.41521 29.9179 6.34026 30.1281 6.19984C30.3382 6.05942 30.5021 5.85984 30.5988 5.62632C30.6955 5.39282 30.7208 5.13587 30.6715 4.88798C30.6222 4.64009 30.5005 4.41239 30.3217 4.23366C30.1431 4.05495 29.9154 3.93324 29.6674 3.88394C29.4195 3.83462 29.1625 3.85992 28.9291 3.95665C28.6956 4.05338 28.496 4.21717 28.3555 4.42732C28.2151 4.63747 28.1402 4.88455 28.1402 5.13729H17.2779C17.2779 4.79836 17.1432 4.47332 16.9036 4.23366C16.664 3.99402 16.3389 3.85938 16 3.85938C15.6611 3.85938 15.336 3.99402 15.0964 4.23366C14.8568 4.47332 14.7221 4.79836 14.7221 5.13729H3.85979C3.85979 4.88455 3.78484 4.63747 3.64442 4.42732C3.504 4.21717 3.30442 4.05338 3.0709 3.95665C2.8374 3.85992 2.58045 3.83462 2.33256 3.88394C2.08467 3.93324 1.85697 4.05495 1.67825 4.23366C1.49953 4.41239 1.37782 4.64009 1.32851 4.88798C1.2792 5.13587 1.30451 5.39282 1.40123 5.62632C1.49795 5.85984 1.66175 6.05942 1.8719 6.19984C2.08205 6.34026 2.32913 6.41521 2.58187 6.41521V20.4723C2.32913 20.4723 2.08205 20.5473 1.8719 20.6876C1.66175 20.8281 1.49795 21.0277 1.40123 21.2612C1.30451 21.4946 1.2792 21.7516 1.32851 21.9995C1.37782 22.2474 1.49953 22.4752 1.67825 22.6538C1.85697 22.8326 2.08467 22.9543 2.33256 23.0036C2.58045 23.0529 2.8374 23.0276 3.0709 22.9309C3.30442 22.8341 3.504 22.6703 3.64442 22.4602C3.78484 22.25 3.85979 22.003 3.85979 21.7502H14.7221C14.7221 22.0891 14.8568 22.4142 15.0964 22.6538C15.336 22.8934 15.6611 23.0281 16 23.0281C16.3389 23.0281 16.664 22.8934 16.9036 22.6538C17.1432 22.4142 17.2779 22.0891 17.2779 21.7502H28.1402C28.1402 22.003 28.2151 22.25 28.3555 22.4602C28.496 22.6703 28.6956 22.8341 28.9291 22.9309C29.1625 23.0276 29.4195 23.0529 29.6674 23.0036C29.9154 22.9543 30.1431 22.8326 30.3217 22.6538C30.5005 22.4752 30.6222 22.2474 30.6715 21.9995C30.7208 21.7516 30.6955 21.4946 30.5988 21.2612C30.5021 21.0277 30.3382 20.8281 30.1281 20.6876C29.9179 20.5473 29.6709 20.4723 29.4181 20.4723Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.7791 28.1405L13.4441 10.8887"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.73501 11.5276C6.55856 11.5276 6.41553 11.3846 6.41553 11.2082C6.41553 11.0317 6.55856 10.8887 6.73501 10.8887"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M6.73511 11.5276C6.91155 11.5276 7.05459 11.3846 7.05459 11.2082C7.05459 11.0317 6.91155 10.8887 6.73511 10.8887"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M9.92983 11.5276C9.75339 11.5276 9.61035 11.3846 9.61035 11.2082C9.61035 11.0317 9.75339 10.8887 9.92983 10.8887"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M9.92993 11.5276C10.1064 11.5276 10.2494 11.3846 10.2494 11.2082C10.2494 11.0317 10.1064 10.8887 9.92993 10.8887"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M23.348 11.5276C23.1716 11.5276 23.0286 11.3846 23.0286 11.2082C23.0286 11.0317 23.1716 10.8887 23.348 10.8887"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M23.3481 11.5276C23.5246 11.5276 23.6676 11.3846 23.6676 11.2082C23.6676 11.0317 23.5246 10.8887 23.3481 10.8887"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M8.652 14.0833C8.47556 14.0833 8.33252 13.9403 8.33252 13.7638C8.33252 13.5873 8.47556 13.4443 8.652 13.4443"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M8.6521 14.0833C8.82854 14.0833 8.97158 13.9403 8.97158 13.7638C8.97158 13.5873 8.82854 13.4443 8.6521 13.4443"
        stroke="#22364A"
        strokeWidth="1.33"
      />
    </svg>
  );
};
